import React from 'react';

const Cardbody = ({children}) => {
    return (
        <div className="p-6">
            {children}
        </div>
    );
};

export default Cardbody;